import * as ActionTypes from './actionTypes.js';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchDevicesStock = (params = {}) => apiActionCreator({
  'endpoint': '/devices/stock',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_DEVICES_STOCK,
    ActionTypes.FETCHED_DEVICES_STOCK,
    [
      ActionTypes.FETCHED_DEVICES_STOCK_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
